import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../modules';
import { setMarkedToolbar } from '../../../modules/editor';
import { ContentsItem } from '../../../modules/editor/types';

// 에디트 모듈
import TextEdit from '../Edit/TextEdit';

type Props = {
	contentItem: ContentsItem
};

function Permalink({ contentItem }: Props) {

	const dispatch = useDispatch();
	
	const markedToolbar = useSelector((state: RootState) => state.editor.markedToolbar);

	const markToolbar = (contentId: number, currentIndex: number, itemType:string) => {
		dispatch(setMarkedToolbar({
			contentId: contentId,
			currentIndex: currentIndex,
			itemType: itemType
		}))
	}

	return (
		<>
			<TextEdit
				contentId={contentItem.id}
				contentIndex={0}
				innerContent={contentItem.content.content[0]}
				style={contentItem.content.style[0].text}
				boxStyle={contentItem.content.style[0].box}
				markToolbar={markToolbar}
				markedToolbar={markedToolbar}
				contentCategory="permalink"
			/>
		</>
	)
}

export default Permalink;